import script from "./PhoneVerify.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneVerify.vue?vue&type=script&setup=true&lang=js"

import "./PhoneVerify.vue?vue&type=style&index=0&id=95d4831a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95d4831a"]])

export default __exports__